import { ActionPrompt } from './action-prompt';
import { AudioPlayer } from './audio';
import axios from 'axios';

export class FinalScene {
	protected sceneElements = {
		butterfly: {
			cartonHover: document.querySelector('.butterfly-with-carton-hover-container') as HTMLElement,
			cartonContainer: document.querySelector('.butterfly-with-carton') as HTMLElement,
			one: document.querySelector('.butterfly.one') as any as HTMLImageElement,
			two: document.querySelector('.butterfly.two') as any as HTMLImageElement,
		},
		fox: document.querySelector('#fox') as any as HTMLImageElement,
		finalFlower: {
			one: document.querySelector('.final-flower.one') as any as HTMLImageElement,
			two: document.querySelector('.final-flower.two') as any as HTMLImageElement,
		},
		gradientBackground: document.querySelector('#final-scene-gradient-background') as any as HTMLImageElement,
		grass: {
			one: document.querySelector('#grass-one') as any as HTMLImageElement,
			two: document.querySelector('#grass-two') as any as HTMLImageElement,
		},
		greenHill: document.querySelector('#green-hill') as any as HTMLImageElement,
		greenLand: document.querySelector('#green-land') as any as HTMLImageElement,
		pinkOverlay: document.querySelector('#pink-overlay') as any as HTMLImageElement,
		justWaterBottles: {
			one: document.querySelector('.just-water-bottles.one') as any as HTMLImageElement,
			two: document.querySelector('.just-water-bottles.two') as any as HTMLImageElement,
			three: document.querySelector('.just-water-bottles.three') as any as HTMLImageElement,
			four: document.querySelector('.just-water-bottles.four') as any as HTMLImageElement,
		},
		justWaterBottlesActionHelper: {
			one: document.querySelector('.just-water-bottles-action-helper.one') as any as HTMLImageElement,
			two: document.querySelector('.just-water-bottles-action-helper.two') as any as HTMLImageElement,
			three: document.querySelector('.just-water-bottles-action-helper.three') as any as HTMLImageElement,
			four: document.querySelector('.just-water-bottles-action-helper.four') as any as HTMLImageElement,
		},
		justWaterBottlesContainer: document.querySelector('.just-water-bottles-container') as HTMLElement,
		plasticBottles: {
			one: document.querySelector('.plastic-bottles.one') as any as HTMLImageElement,
			two: document.querySelector('.plastic-bottles.two') as any as HTMLImageElement,
			three: document.querySelector('.plastic-bottles.three') as any as HTMLImageElement,
			four: document.querySelector('.plastic-bottles.four') as any as HTMLImageElement,
		},
		plasticBottlesContainer: document.querySelector('.plastic-bottles-container') as HTMLElement,
		plasticBottlesOverlay: document.querySelector('#plastic-bottles-overlay') as any as HTMLImageElement,
		productShelfContainer: document.querySelector('.product-shelf') as HTMLElement,
		productShelfGreeneryContainer: document.querySelector('.product-shelf-greenery-overlay') as HTMLElement,
		productShelfBack: document.querySelector('#product-shelf-back') as any as HTMLImageElement,
		mountains: document.querySelector('#final-scene-mountain') as any as HTMLImageElement,
		sceneContainer: document.querySelector('.final-scene-container') as HTMLElement,
		shelf: {
			one: document.querySelector('.shelf.one') as any as HTMLImageElement,
			two: document.querySelector('.shelf.two') as any as HTMLImageElement,
			three: document.querySelector('.shelf.three') as any as HTMLImageElement,
			four: document.querySelector('.shelf.four') as any as HTMLImageElement,
		},
		signPost: {
			top: document.querySelector('.sign-post.top') as any as HTMLImageElement,
			topLink: document.querySelector('#sign-post-top-link') as any as HTMLImageElement,
			bottom: document.querySelector('.sign-post.bottom') as any as HTMLImageElement,
			bottomLink: document.querySelector('#sign-post-bottom-link') as any as HTMLImageElement,
			post: document.querySelector('.sign-post.post') as any as HTMLImageElement,
		},
		singleJustWaterBottle: document.querySelector('.butterfly-with-carton .carton') as any as HTMLImageElement,
		sky: document.querySelector('#sky') as any as HTMLImageElement,
		transportScene: document.querySelector('#transport-scene-container'),
		links: {
			top: document.querySelector('#sign-post-top-link') as HTMLElement,
			bottom: document.querySelector('#sign-post-bottom-link') as HTMLElement,
		},
	};

	private audioPlayer = AudioPlayer.getInstance();
	private actionHelper = ActionPrompt.getInstance();

	private region = 'US';
	private userInteracted = false;
	private timeouts: any[] = [];

	public createElements(): void {
		this.sceneElements.productShelfBack.src = './static/images/cork-backing.png';
		this.sceneElements.shelf.one.src = './static/images/shelf.png';
		this.sceneElements.shelf.two.src = './static/images/shelf.png';
		this.sceneElements.shelf.three.src = './static/images/shelf.png';
		this.sceneElements.shelf.four.src = './static/images/shelf.png';
		this.sceneElements.justWaterBottles.one.src = './static/images/just-water-bottles-group-row.png';
		this.sceneElements.justWaterBottles.two.src = './static/images/just-water-bottles-group-row.png';
		this.sceneElements.justWaterBottles.three.src = '../static/images/just-water-bottles-group-row-missing-bottle.png';
		this.sceneElements.justWaterBottles.four.src = './static/images/just-water-bottles-group-row.png';
		this.sceneElements.justWaterBottlesActionHelper.one.src = '../static/images/just-water-bottles-group-row-white-overlay.png';
		this.sceneElements.justWaterBottlesActionHelper.two.src = '../static/images/just-water-bottles-group-row-white-overlay.png';
		this.sceneElements.justWaterBottlesActionHelper.three.src = '../static/images/just-water-bottles-group-row-white-overlay.png';
		this.sceneElements.justWaterBottlesActionHelper.four.src = '../static/images/just-water-bottles-group-row-white-overlay.png';
		this.sceneElements.plasticBottles.one.src = './static/images/plastic-bottles-group-row.png';
		this.sceneElements.plasticBottles.two.src = './static/images/plastic-bottles-group-row.png';
		this.sceneElements.plasticBottles.three.src = './static/images/plastic-bottles-group-row.png';
		this.sceneElements.plasticBottles.four.src = './static/images/plastic-bottles-group-row.png';
		this.sceneElements.plasticBottlesOverlay.src = './static/images/plastic-bottles.png';
		this.sceneElements.greenHill.src = './static/images/green-hill.png';
		this.sceneElements.greenLand.src = './static/images/green-land.png';
		this.sceneElements.grass.one.src = './static/images/final-scene-grass-one.png';
		this.sceneElements.grass.two.src = './static/images/final-scene-grass-two.png';
		this.sceneElements.fox.src = './static/images/fox-animation.gif';
		this.sceneElements.mountains.src = './static/images/final-scene-mountains.png';
		this.sceneElements.pinkOverlay.src = './static/images/final-scene-pink-overlay.png';
		this.sceneElements.sky.src = './static/images/final-scene-sky.png';
		this.sceneElements.finalFlower.one.src = './static/images/final-scene-flower-one.png';
		this.sceneElements.finalFlower.two.src = './static/images/final-scene-flower-one.png';
		this.sceneElements.signPost.top.src = './static/images/just-water-sign-top.png';
		this.sceneElements.signPost.bottom.src = './static/images/just-water-sign-bottom.png';
		this.sceneElements.signPost.post.src = './static/images/just-water-sign-post.png';
		this.sceneElements.butterfly.one.src = './static/images/butterfly.gif';
		this.sceneElements.butterfly.two.src = './static/images/butterfly.gif';
		this.sceneElements.singleJustWaterBottle.src = '../static/images/single-just-water-bottle.png';
		this.sceneElements.gradientBackground.src = '../static/images/final-scene-gradient-background.jpg';
	}

	public init(): void {
		this.sceneElements.sceneContainer.style.display = 'block';
		this.getRegion();

		setTimeout(() => {
			this.animateItemsIn();
		}, 300);

		setTimeout(() => {
			this.sceneElements.transportScene.style.display = 'none';
			this.audioPlayer.voiceOvers.final.play();
			this.audioPlayer.voiceOvers.final.on('end', () => {
				if (!this.userInteracted) {
					this.listenForPlasticBottlesClick();
				}
			});
		}, 1000);

		this.listenForJustWaterBottlesClick();
		this.listenForSignPostClicks();
	}

	private getRegion(): void {
		axios.get('https://freegeoip.app/json/').then((result) => {
			if (result.data.country_code === 'AU') {
				this.region = 'AU';
			}
		});
	}

	private animateItemsIn(): void {
		this.sceneElements.shelf.one.classList.add('fall');
		this.sceneElements.shelf.two.classList.add('fall');
		this.sceneElements.shelf.three.classList.add('fall');
		this.sceneElements.shelf.four.classList.add('fall');

		setTimeout(() => {
			this.sceneElements.justWaterBottles.one.classList.add('fall');
			this.sceneElements.justWaterBottles.two.classList.add('fall');
			this.sceneElements.butterfly.cartonContainer.classList.add('fall');
			this.sceneElements.justWaterBottles.three.classList.add('fall');
			this.sceneElements.justWaterBottles.four.classList.add('fall');
		}, 300);
		setTimeout(() => {
			this.sceneElements.plasticBottles.one.classList.add('fall');
			this.sceneElements.plasticBottles.two.classList.add('fall');
			this.sceneElements.plasticBottles.three.classList.add('fall');
			this.sceneElements.plasticBottles.four.classList.add('fall');
		}, 600);

		this.timeouts.push(
			setTimeout(() => {
				this.sceneElements.justWaterBottlesActionHelper.one.classList.add('pulse');
				this.sceneElements.justWaterBottlesActionHelper.two.classList.add('pulse');
				this.sceneElements.justWaterBottlesActionHelper.three.classList.add('pulse');
				this.sceneElements.justWaterBottlesActionHelper.four.classList.add('pulse');
			}, 7000)
		);

		this.timeouts.push(
			setTimeout(() => {
				this.actionHelper.showActionPrompt('50%', '47%');
			}, 10000)
		);

		this.timeouts.push(
			setTimeout(() => {
				this.sceneElements.justWaterBottlesContainer.click();
			}, 15000)
		);
	}

	private listenForPlasticBottlesClick(): void {
		this.audioPlayer.soundFx.general.wrongActionChime.play();

		this.sceneElements.plasticBottles.one.classList.add('fall-further');
		this.sceneElements.plasticBottles.two.classList.add('fall-further');
		this.sceneElements.plasticBottles.three.classList.add('fall-further');
		this.sceneElements.plasticBottles.four.classList.add('fall-further');

		this.sceneElements.plasticBottlesOverlay.style.opacity = '1';
		setTimeout(() => {
			this.sceneElements.plasticBottlesOverlay.style.opacity = '0';
		}, 1500);
	}

	private listenForJustWaterBottlesClick(): void {
		this.sceneElements.justWaterBottlesContainer.addEventListener('click', () => {
			this.userInteracted = true;
			this.sceneElements.productShelfContainer.style.animation = 'none';

			this.sceneElements.justWaterBottlesActionHelper.one.classList.remove('pulse');
			this.sceneElements.justWaterBottlesActionHelper.two.classList.remove('pulse');
			this.sceneElements.justWaterBottlesActionHelper.three.classList.remove('pulse');
			this.sceneElements.justWaterBottlesActionHelper.four.classList.remove('pulse');
			this.actionHelper.hideActionPrompt();
			this.timeouts.forEach((timeout: any) => {
				clearTimeout(timeout);
			});

			this.sceneElements.butterfly.two.classList.add('appear');
			setTimeout(() => {
				this.sceneElements.butterfly.cartonHover.classList.add('fly');
				this.sceneElements.butterfly.cartonContainer.classList.add('fly-off-shelf');
			}, 500);

			setTimeout(() => {
				this.sceneElements.productShelfGreeneryContainer.style.display = 'block';
				this.audioPlayer.soundFx.general.correctActionChime.play();
				this.audioPlayer.soundFx.finalScene.brightDrone.play();
				this.audioPlayer.soundFx.finalScene.forrestSounds.play();

				setTimeout(() => {
					this.sceneElements.productShelfBack.style.top = '150%';
					this.sceneElements.shelf.one.classList.add('fall-further');
					this.sceneElements.shelf.two.classList.add('fall-further');
					this.sceneElements.shelf.three.classList.add('fall-further');
					this.sceneElements.shelf.four.classList.add('fall-further');
					this.sceneElements.justWaterBottles.one.classList.add('fall-further');
					this.sceneElements.justWaterBottles.two.classList.add('fall-further');
					this.sceneElements.justWaterBottles.three.classList.add('fall-further');
					this.sceneElements.justWaterBottles.four.classList.add('fall-further');
					this.sceneElements.plasticBottles.one.classList.add('fall-further');
					this.sceneElements.plasticBottles.two.classList.add('fall-further');
					this.sceneElements.plasticBottles.three.classList.add('fall-further');
					this.sceneElements.plasticBottles.four.classList.add('fall-further');
					this.sceneElements.links.top.style.display = 'block';
					this.sceneElements.links.bottom.style.display = 'block';
				}, 1000);
			}, 1500);
		});
	}

	private listenForSignPostClicks(): void {
		this.sceneElements.signPost.topLink.addEventListener('click', () => {
			if (this.region === 'AU') {
				window.location.href = 'https://justwater.com/pages/australia';
			} else {
				window.location.href = 'https://justwater.com/collections/just-water';
			}
		});

		this.sceneElements.signPost.bottomLink.addEventListener('click', () => {
			window.location.href = 'https://justwater.com/pages/AR';
		});
	}
}
